export const SHOW_DIALOG = Symbol('SHOW_DIALOG');
export const HIDE_DIALOG = Symbol('HIDE_DIALOG');
export const SET_DIALOG_DATA = Symbol('SET_DIALOG_DATA');
export const RESET_DIALOG = Symbol('RESET_DIALOG');

/**
 * @param {string} dialogName
 * @param {*} data
 * @returns {{payload: {dialogName: *}, type: symbol}}
 */
export const showDialogAction = (dialogName, data = {}) => ({
  type: SHOW_DIALOG,
  payload: { dialogName, data },
});

/**
 * @param {string} dialogName
 * @returns {{payload: {dialogName: *}, type: symbol}}
 */
export const hideDialogAction = (dialogName) => ({
  type: HIDE_DIALOG,
  payload: { dialogName },
});

/**
 * @param {string} dialogName
 * @param {*} data
 * @return {{payload: {data: *, dialogName: *}, type: symbol}}
 */
export const setDialogDataAction = (dialogName, data) => ({
  type: SET_DIALOG_DATA,
  payload: { dialogName, data },
});

/**
 * @param dialogName
 * @return {{payload: {dialogName: *}, type: symbol}}
 */
export const resetDialogAction = (dialogName) => ({
  type: RESET_DIALOG,
  payload: { dialogName },
});
